import React from "react"

function IconBellSlash({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="bell-slash"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-bell-slash"
      {...props}
    >
      <path
        d="m6.302 9.052 1.185 1.109-.003.12v3.387l-1.69 1.691v1.303l8.624-.001 1.398 1.31h-.334a3.382 3.382 0 0 1-6.76 0H5.467a.982.982 0 0 1-.974-.858l-.007-.123v-1.765c0-.217.071-.427.202-.597l.085-.097 1.402-1.405.001-2.846c0-.421.044-.832.127-1.228zM3.627 3.268l.093.073 17.455 16.363a.655.655 0 0 1-.802 1.028l-.093-.073L2.825 4.296a.655.655 0 0 1 .802-1.028zm10.544 14.704h-4.138a2.073 2.073 0 0 0 4.138 0zM12.136 2.474a1.94 1.94 0 0 1 1.94 1.94.654.654 0 0 1-.036.217 5.963 5.963 0 0 1 4.05 5.388l.006.261v2.846L19.5 14.53c.122.123.21.275.254.44l.025.126.008.129v1.683l-1.31-1.227v-.322l-1.69-1.69V10.28a4.651 4.651 0 0 0-7.76-3.46l-.958-.898a5.957 5.957 0 0 1 2.163-1.292.627.627 0 0 1-.037-.215 1.94 1.94 0 0 1 1.94-1.94zm0 1.31a.63.63 0 0 0-.623.528l-.003.04.192-.017.194-.01.24-.005.315.008.31.024-.002-.04a.631.631 0 0 0-.623-.528z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconBellSlash
